import React from 'react'
import {
  SGPageTemplateProductCollection,
  SGPageTemplateProductCollectionKind,
} from '../../../../../src/types/page-templates'
import { ModuleComponent, ModuleProps } from '../types'
import SGPageTemplateContentCollectionProductReelModule from './content-collection/product-reel'
import SGPageTemplateContentCollectionDeckModule from './content-collection/collection-deck'

export default function SGPageTemplateProductCollectionModule({
  module,
}: ModuleProps<SGPageTemplateProductCollection>): JSX.Element | null {
  const Component = moduleComponents[module.kind]
  if (!Component) {
    console.log(`Unsupported product collection kind: ${module.kind}`)
    return null
  }
  return <Component module={module} />
}

const moduleComponents: {
  [key in SGPageTemplateProductCollectionKind]: ModuleComponent<SGPageTemplateProductCollection>
} = {
  COLLECTION_DECK: SGPageTemplateContentCollectionDeckModule,
  PRODUCT_REEL: SGPageTemplateContentCollectionProductReelModule,
}
